class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector('details');
		this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

		this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
		this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
	}

	onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.close();
		});
	}

	onToggle() {
		if (!this.animations) this.animations = this.content.getAnimations();

		if (this.mainDetailsToggle.hasAttribute('open')) {
			this.animations.forEach(animation => animation.play());
		} else {
			this.animations.forEach(animation => animation.cancel());
		}
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open');
		this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
	}
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
	constructor() {
		super();
		this.header = document.querySelector('.header-wrapper');
		this.itemMenu = document.querySelectorAll('.header-wrapper a.header__menu-item');
		this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
		this.mainDetailsToggle.closest('.section-header:has(.header-wrapper)').addEventListener('mouseleave', this.onMouseLeave.bind(this));

		this.grandChildrens = this.content.querySelector('.mega-menu__grandchildren');
		this.grandChildrens ? this.listenerGrandChildrens() : null;

		for (const item of this.itemMenu) {
			item.addEventListener('mouseenter', this.onRemoveActive.bind(this));
		}
	}


	onToggle() {
		if (!this.header) return;
		this.header.preventHide = this.mainDetailsToggle.open;
		(this.header.preventHide) ?
			this.header.classList.add('transparent-menu-open') :
			this.header.classList.remove('transparent-menu-open');
		this.header.preventHide ? document.body.classList.add('has-overlay') : document.body.classList.remove('has-overlay');
		if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
		document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
	}

	onRemoveActive() {
		for (const itemMegaMenu of this.header.querySelectorAll('details')) {
			itemMegaMenu.removeAttribute('open');
			itemMegaMenu.querySelector('summary').setAttribute('aria-expanded', false);
		}
	}

	onMouseEnter() {
		if (this.mainDetailsToggle.hasAttribute('open')) return;
		for (const itemMegaMenu of this.header.querySelectorAll('details')) {
			itemMegaMenu.removeAttribute('open');
			itemMegaMenu.querySelector('summary').setAttribute('aria-expanded', false);
		}
		this.mainDetailsToggle.setAttribute('open', '');
		this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
	}


	listenerGrandChildrens() {
		if (this.grandChildrens) {
			this.grandChildrens.querySelectorAll('li').forEach((li) => {
				li.addEventListener('mouseenter', () => {
					this.grandChildrens.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
					this.querySelectorAll('.mega-menu__list-big li').forEach((li) => li.classList.remove('active'));
					this.querySelector(`.mega-menu__list-big li[data-menu-index="${li.dataset.menuIndex}"]`).classList.add('active');
					li.classList.add('active');
				});
			});
		}
	}

	onMouseLeave() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.close();
		});
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open');
		this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
	}
}

customElements.define('header-menu', HeaderMenu);
